import vx404Page from '../components/nfr/vx-404-page/vx-404-page.vue';
import vx500Page from '../components/nfr/vx-500-page/vx-500-page.vue';


const nfrModule = {
  components: {
    vx404Page,
    vx500Page,
  },
};

export default nfrModule;



// WEBPACK FOOTER //
// ./src/modules/nfr.js